import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AuthState, User } from '../types';
import { getAuthFromStorage, saveAuthToStorage, clearAuthFromStorage } from '../utils';

interface AuthContextType extends AuthState {
  login: (token: string, user: User) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [authState, setAuthState] = useState<AuthState>(() => {
    const storedAuth = getAuthFromStorage();
    return {
      isAuthenticated: storedAuth.isAuthenticated,
      token: storedAuth.token,
      user: storedAuth.user
    };
  });

  const login = (token: string, user: User) => {
    saveAuthToStorage(token, user);
    setAuthState({
      isAuthenticated: true,
      token,
      user
    });
  };

  const logout = () => {
    // 清除分享状态
    localStorage.removeItem('current_share_id');
    
    // 清除认证信息
    clearAuthFromStorage();
    setAuthState({
      isAuthenticated: false,
      token: null,
      user: null
    });
  };

  return (
    <AuthContext.Provider value={{ ...authState, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 